import { call, put, takeLatest } from 'redux-saga/effects';

import { handleSagaError } from '»utils/handleSagasError';

import { userInfoServices } from './userInfo.services';
import { userInfoSlice } from './userInfo.slice';

const userInfoWorker = function* () {
  try {
    const userInfo = yield call(userInfoServices.getUserInfo);

    yield put(userInfoSlice.actions.userInfoSucess(userInfo));
  } catch (error) {
    const handled = yield call(handleSagaError, error);
    if (!handled) yield put(userInfoSlice.actions.userInfoFailure());
  }
};

export const userInfoSagas = function* () {
  yield takeLatest(userInfoSlice.actions.userInfoRequest.type, userInfoWorker);
};
